import { minLength, maxLength, stringPattern, stringPatternError, tagMinLength, tagMaxLength } from '../../utils/form-validations';

export const addMachineDefaultFields = {
  id: 0,
  onto_manage_id: null,
  machine_id: 0,
  machine_name: '',
  machine_manufacturer: '',
  machine_type: '',
  part_no: null,
  machine_tags: [],
  machine_parts: [],
};

export const machineExcelSchema = {
  machine_name: '',
  machine_manufacturer: '',
  machine_type: '',
  machine_tags: []
};

export const partsExcelSchema = { part_name: '', part_tags:[] };

// Machine
export const machineDetailsUISchema = [
  { id: 1, label: 'Ontology', name: 'onto_manage_id', type: 'ontology', required: true },
  { id: 2, label: 'Machine Name', name: 'machine_name', type: 'input', required: true },
  { id: 3, label: 'Machine Manufacturer', name: 'machine_manufacturer', type: 'input', required: true },
  { id: 4, label: 'Machine Type', name: 'machine_type', type: 'input', required: true },
];

export const machineDetailsSchema = {
  type: 'object',
  properties: {
    onto_manage_id: { type: 'number', minLength: 1, maxLength },
    machine_name: {
      type: 'string',
      minLength,
      maxLength,
      // pattern: stringPattern,
      // errorMessage: { pattern: stringPatternError },
    },
    machine_manufacturer: {
      type: 'string',
      minLength,
      maxLength,
      pattern: stringPattern,
      errorMessage: { pattern: stringPatternError },
    },
    machine_type: {
      type: 'string',
      minLength,
      maxLength,
      pattern: stringPattern,
      errorMessage: { pattern: stringPatternError },
    },
  },
  required: ['onto_manage_id', 'machine_name', 'machine_manufacturer', 'machine_type'],
  additionalProperties: true,
};

export const machineTagsSchema = {
  type: 'object',
  properties: {
    id: { type: 'number' },
    key: {
      type: 'string',
      minLength: tagMinLength,
      maxLength: tagMaxLength,
      pattern: stringPattern,
      errorMessage: { pattern: stringPatternError },
    },
    value: {
      type: 'string',
      minLength: tagMinLength,
      maxLength: tagMaxLength,
      pattern: stringPattern,
      errorMessage: { pattern: stringPatternError },
    }
  },
  required: ['key', 'value'],
  additionalProperties: true,
};

// Parts
export const addPartDefault = { id: 1, part_name: '', part_tags:[] };

export const partDetailsUISchema = [{ id: 1, label: 'Part Name', name: 'part_name', type: 'input' }];

export const partDetailsSchema = {
  type: 'object',
  properties: {
    part_name: {
      type: 'string',
      minLength,
      maxLength,
      // pattern: stringPattern,
      // errorMessage: { pattern: stringPatternError },
    },
  },
  required: ['part_name'],
  additionalProperties: true,
};

export const partTagsSchema = {
  type: 'object',
  properties: {
    id: { type: 'number' },
    key: {
      type: 'string', minLength: tagMinLength,
      maxLength: tagMaxLength, pattern: stringPattern
    },
    value: {
      type: 'string', minLength: tagMinLength,
      maxLength: tagMaxLength, pattern: stringPattern
    },
  },
  required: ['key', 'value'],
};
